import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'components/Modal';
import OrderTable from 'components/OrderTable';

export default class ReceiptModal extends React.Component {
  static propTypes = {
    order: PropTypes.object.isRequired,
    handleHideModal: PropTypes.func,
  };

  render() {
    const { order, handleHideModal, currency } = this.props;

    return (
      <Modal handleHideModal={handleHideModal} className="ReceiptModal">
        <h2>{`Ordrenr. ${order.ORDER_ID}`}</h2>
        <OrderTable order={order} currency={currency} />
        <div className="text-center">
          <button className="cancel" onClick={handleHideModal}>
            Lukk vindu
          </button>
        </div>
      </Modal>
    );
  }
}
